import React, { ReactNode, useState, useEffect, useCallback } from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/system';
import { MAX_WIDTH_CONTAINER_NotImprotant } from '../../config/cacheKey';
import { setHeaderTitle } from '../../redux/headerTitle/headerTitleSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useAppBar } from '../appBar/appBarContext';
import { head } from 'lodash';
import { RootState } from '../../redux/store';

const panelHeightHalf = 60; // 75vh
const panelHeightFull = 94; // 90vh

const PanelContent = styled(Box)({
    transition: 'height 0.3s ease',
    overflowY: 'hidden',
});

const ScrollableContent = styled(Box)({
    // height: '100%',
    height: 'calc(100% - 40px)',
    overflowY: 'auto',
    overflowX: 'hidden', // Prevent horizontal overflow
    WebkitOverflowScrolling: 'touch',
});

const PanelHandle = styled(Box)({
    width: '100%',
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'grab',
    '&::before': {
        content: '""',
        width: '80px',
        height: '5px',
        backgroundColor: '#ccc',
        borderRadius: '3px',
    },
});

const SwipeablePanel = ({ children, isAssigned }: { children: ReactNode, isAssigned: boolean }) => {
    const [height, setHeight] = useState(panelHeightHalf);
    const [startY, setStartY] = useState<number | null>(null);
    const [isDragging, setIsDragging] = useState(false);
    const dispatch = useDispatch();

    const { title, parentRoute } = useAppBar();
    const colorState = useSelector((state: RootState) => state.headerTitleSlice.color);
    useEffect(() => {
        dispatch(setHeaderTitle({
            color: isAssigned && colorState ? colorState :
                isAssigned ? 'var(--header-color)' : 'var(--input-bg-color)', header: title, parentRoute: parentRoute
        }));
    }, [title]);

    useEffect(() => {
        const preventDefaultTouchMove = (event: TouchEvent) => {
            if (isDragging) {
                event.preventDefault();
            }
        };

        document.addEventListener('touchmove', preventDefaultTouchMove, {
            passive: false,
        });

        return () => {
            document.removeEventListener('touchmove', preventDefaultTouchMove);
        };
    }, [isDragging]);

    const handleMouseClick = () => {
        setHeight((prevHeight) =>
            prevHeight === panelHeightHalf ? panelHeightFull : panelHeightHalf
        );
    };

    const handleDragStart = (event: React.TouchEvent | React.MouseEvent) => {
        // event.preventDefault();
        setIsDragging(true);
        if ('touches' in event) {
            setStartY(event.touches[0].clientY);
        } else {
            setStartY(event.clientY);
        }
    };

    const handleDragMove = (event: React.TouchEvent | React.MouseEvent) => {
        // event.preventDefault();
        if (!isDragging || startY === null) return;

        let clientY;
        if ('touches' in event) {
            clientY = event.touches[0].clientY;
        } else {
            clientY = event.clientY;
        }

        const deltaY = startY - clientY;
        let newHeight = height + deltaY * 0.2;

        newHeight = Math.max(
            panelHeightHalf,
            Math.min(newHeight, panelHeightFull)
        );

        setHeight(newHeight);
        setStartY(clientY);
    };

    const handleDragEnd = (event: React.TouchEvent | React.MouseEvent) => {
        // event.preventDefault();
        setIsDragging(false);
        setStartY(null);
        setHeight((prevHeight) =>
            prevHeight > (panelHeightHalf + panelHeightFull) / 2
                ? panelHeightFull
                : panelHeightHalf
        );
    };

    return (
        <Box
            className="px-5 containerMedia"
            sx={{
                position: 'fixed',
                bottom: 0,
                left: 0,
                right: 0,
                height: `${height}svh`,
                zIndex: 1200,
                // backgroundColor: 'white',
                // boxShadow: '0px -2px 10px rgba(0, 0, 0, 0.1)',
                borderRadius: '0',
                maxWidth: MAX_WIDTH_CONTAINER_NotImprotant,
                // maxWidth: '900px',
                margin: 'auto',
                overflow: 'hidden',
                overflowX: 'hidden',
                marginBottom: '57px',
                background: 'var(--bg-color)'

            }}
        // onTouchStart={handleDragStart}
        // onTouchMove={handleDragMove}
        // onTouchEnd={handleDragEnd}
        >
            {/* <PanelContent
                sx={{ height: `${height}vh` }}
                sx={{ height: "100%" }}
            >
                <PanelHandle
                cmt dispatch setheader
                onClick={handleMouseClick}
                onTouchStart={handleDragStart}
                onTouchMove={handleDragMove}
                onTouchEnd={handleDragEnd}
                Uncomment if mouse drag is needed
                onMouseDown={handleDragStart}
                onMouseMove={handleDragMove}
                onMouseUp={handleDragEnd}
                />
            </PanelContent> */}
            <div style={{ height: '100%', marginTop: '1rem' }}>

                <ScrollableContent className='scrollableContent'>{children}</ScrollableContent>
            </div>
        </Box>
    );
};

export default SwipeablePanel;
